export default __webpack_public_path__ + "static/media/landscape33.6d95fb05.jpeg";